// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Sidebar__wrapper__1au7U","logo":"Sidebar__logo__13mgY","nav":"Sidebar__nav__3u_pH","link":"Sidebar__link__221Lu","active":"Sidebar__active__KIEOU"};


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/sidebar/Sidebar.scss
// module id = 257
// module chunks = 0